import { isEmpty } from '@sgme/fp';

export function getQuoteIdFromUrl(hashUrl: string): string | null {
  if (!hashUrl.includes('/quote/')) {
    return null;
  }
  const parts = hashUrl.split('/');
  const lastPart = parts[parts.length - 1];
  return lastPart;
}

export function getRfqIdFromUrl(hashUrl: string): string | null {
  if (!hashUrl.includes('/sharable-quote/')) {
    return null;
  }
  const parts = hashUrl.split('/');
  const lastPart = parts[parts.length - 1];
  return lastPart;
}

export function getEnvironment(config: SgmeConfiguration): string | null {
  const label = config.envLabel;
  if (isEmpty(label)) {
    return null;
  }
  return label;
}

export function isProductionEnvironment(envLabel: string | null) {
  return envLabel === null;
}
